import React from 'react'
import { Link } from 'react-router-dom';
import { removeUserSession } from '../utils';




export default function SignOut() {

    removeUserSession();
    return (
        <div className=" hold-transition ">
            <div className="login-box">
                <div className="login-logo">
                    <a href="/cms"><b>CJIT</b>ADMIN</a>
                </div>
                <div className="card">
                    <div className="card-body login-card-body">
                        <p className="login-box-msg color-primary">You signed out successfully</p>
                        <p className="login-box-msg  color-primary"><Link to="/cms/login">Back To login</Link></p>
                    </div>
                </div>
            </div>

        </div>
    )

}
